'use client';

import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { ChevronDown } from '@/app/components/icons/ChevronDown';
import { cn } from '@/app/utils';
import { BODY, SECTION_TITLE, SUBHEAD } from '../_constants/typography';

const FAQ_KEYS = ['q1', 'q2', 'q3', 'q4', 'q5'] as const;

export function QuestionSection() {
  const t = useTranslations('vidu-r1');
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="relative w-full bg-black px-8 py-20 text-white sm:px-4 sm:py-12">
      <div className="mx-auto flex w-full max-w-[900px] flex-col">
        <h2
          data-reveal
          className={cn(
            'mb-14 text-balance text-center font-semibold tracking-[-1.5px] sm:mb-10 sm:tracking-[-0.5px]',
            SECTION_TITLE,
          )}
          // biome-ignore lint/security/noDangerouslySetInnerHtml: controlled i18n HTML fragment
          dangerouslySetInnerHTML={{ __html: t.raw('faq.title') as string }}
        />

        <div className="divide-y divide-white/10 border-white/10 border-y">
          {FAQ_KEYS.map((key, index) => {
            const isOpen = openIndex === index;
            return (
              <div key={key} data-reveal data-reveal-delay={String(Math.min(index, 5))}>
                <button
                  type="button"
                  onClick={() => setOpenIndex(isOpen ? -1 : index)}
                  className="flex w-full cursor-pointer items-center justify-between gap-6 px-2 py-[30px] text-left sm:py-5"
                >
                  <span className={cn('flex-1 font-medium', SUBHEAD)}>{t(`faq.${key}.title`)}</span>
                  <ChevronDown
                    className={cn(
                      'size-4 shrink-0 text-white transition-transform duration-300',
                      isOpen && 'rotate-180',
                    )}
                  />
                </button>
                <div
                  className="grid transition-[grid-template-rows] duration-300 ease-[cubic-bezier(.33,1,.68,1)]"
                  style={{ gridTemplateRows: isOpen ? '1fr' : '0fr' }}
                >
                  <div className="overflow-hidden">
                    <p className={cn('whitespace-pre-line px-2 pb-8 text-white/60 sm:pb-5', BODY)}>
                      {t(`faq.${key}.description`)}
                    </p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
